import {useEffect, useState} from "react";

const TermSelector2 = ({
        term, termSetter , yearMin, yearMax, title,
        disabled = false, hasSummer = false, hasWinter = false
    }) => { //YYYYMM
    const [years, setYears] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [tsTitle, setTSTitle] = useState(title);

    useEffect(() => {
        if(isLoaded)
            return;
        let y = [];
        for(let i = yearMin; i <= yearMax; i++) {
            y.push(i);
        }
        setYears(y);
        setTSTitle(title);
        setIsLoaded(true);
    }, []);

    function handleSemester(event) {
        let year = Math.floor(term/100);
        termSetter(year*100 + parseInt(event.target.value));
    }
    function handleYear(event) {
        let semester = term % 100;
        termSetter(parseInt(event.target.value)*100 + semester);
    }

    /* Need a check to ensure from is before or equal to to */

    return (
        <div className="input-group term-selector" id={title}>
            <select
                className="form-select"
                id={`${title}-semester`}
                name={`${title}-semester`}
                value={term%100}
                onChange={handleSemester}
                disabled={disabled}
            >
                <option value={0}></option>
                <option value={9}>Fall</option>
                {hasWinter && <option value={12}>Winter</option>}
                <option value={1}>Spring</option>
                {hasSummer && <option value={6}>Summer</option>}
            </select>
            <span className="input-group-text">of</span>
            <select
                className="form-select"
                id={`${title}-year`}
                name={`${title}-year`}
                value={Math.floor(term/100)}
                onChange={handleYear}
                disabled={disabled}
            >
                <option value={0}></option>
                {years.map((y) => (
                    <option key={y} value={y}>{y}</option>
                ))}
            </select>
        </div>
    )
}

export default TermSelector2;